import React, { useState } from "react";
import TextInput from "../../../Global Functions/textInput";
import AddImage from "../../../Global Functions/addImage";
import { useDispatch } from "react-redux";
import { addBrand } from "../../../Redux/Actions/brandsActions";
import toast from "react-hot-toast";

const AddBrandsModal = ({ popTrigger }) => {
  const [brandData, setBrandData] = useState({
    name: "",
    image: "",
  });

  const dispatch = useDispatch();

  const handleCloseTrigger = () => {
    popTrigger();
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setBrandData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const response = await dispatch(addBrand(brandData));
      if (response.statusCode === 200) {
        const newBrand = response.data;
        popTrigger(newBrand);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleImageChange = async (event) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) return;
    const responseUrl = await AddImage(uploadedFile);
   
    if (responseUrl) {
      setBrandData((prevData) => ({
        ...prevData,
        image: responseUrl,
      }));
    }
  };

  return (
    <div className="modal-overlay border-1-grey">
      <div className="modal  bg-white padding-20 border-10">
        <h2>Add Brand</h2>
        <div>
          <TextInput
            label="Add Brand"
            name="name"
            type="text"
            required
            value={brandData.name}
            onChange={handleAddChange}
          ></TextInput>
          <TextInput
            forImage={true}
            htmlFor="image"
            type="file"
            required
            span="Brand Logo"
            label="Click to Upload Image"
            id="image"
            name="image"
            onChange={(event) => {
              handleImageChange(event);
            }}
          ></TextInput>
        </div>
        <div className="flex-container gap-10 flex-justify-around margin-h-10">
          <button onClick={handleSubmit} className="button-class-white">
            Submit
          </button>
          <button
            onClick={() => handleCloseTrigger()}
            className="button-class-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBrandsModal;
